import { VisualAsset, VisualAssetType } from 'core/flow/entities';

export const getVisualAssetImageSrc = (image?: VisualAsset) => {
  if (!image) return undefined;
  if (image.type && image.type !== VisualAssetType.IMAGE) return undefined;

  return image.src;
};
